import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../common/models';
import {
  TransportFiltersInitialState,
  TransportFiltersLoad,
  TransportFiltersUpdate,
} from './transport-filters.actions';
import { TransportFiltersState } from './transport-filters.state';
import { TransportFilterName } from '../constants';

@Injectable({ providedIn: 'root' })
export class TransportFiltersFacade implements LoadDataFacade, SetInitialStateFacade {
  items$: Observable<TransportFilterName[]> = this.store.select(TransportFiltersState.getItems);
  loaded$: Observable<boolean> = this.store.select(TransportFiltersState.getLoaded);

  constructor(private store: Store) {}

  loadAll(): void {
    this.store.dispatch(new TransportFiltersLoad());
  }

  updateFilters(filters: TransportFilterName[]): void {
    this.store.dispatch(new TransportFiltersUpdate(filters));
  }

  setInitialState(): void {
    this.store.dispatch(new TransportFiltersInitialState());
  }
}
